import { Component, inject, model } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ServiciosService } from '../services/servicios.service';
import { AccessService } from '../../core/services/access.service';
import { Servicio } from '../models/servicio.model';
import { ServicioFormComponent } from "../servicio-form/servicio-form.component";
import { ServicioInterface } from '../interfaces/servicio.interface';

@Component({
  selector: 'app-servicio-edit',
  standalone: true,
  imports: [ServicioFormComponent],
  templateUrl: './servicio-edit.component.html',
  styleUrl: './servicio-edit.component.css'
})
export class ServicioEditComponent {
  private route = inject(ActivatedRoute)
  private service = inject(ServiciosService)

  protected access = inject(AccessService).access
  protected id!: string | null;

  value = model<Servicio | undefined>(undefined)
  constructor() {}
  ngOnInit(): void {
    this.service.title.update((value) => 'Dealles del Servicio')
    this.route.paramMap.subscribe(params => {
      this.id = params.get('id');
      this.service.get(params.get('id')).subscribe(data => {
        this.value.update(value => (value = new Servicio(data as ServicioInterface)));
      });
    });
  }
}
